import { PubSub } from '../../../_common/PubSub/PubSub.js';

/* @ngInject */
function PriceAmountCartCtrl($http, $q) {
  const ctrl = this;
  ctrl.$postLink = function () {
    ctrl.getItems();
    PubSub.subscribe('cart.remove', ctrl.getItems);
    PubSub.subscribe('cart.clear', ctrl.getItems);
    PubSub.subscribe('cart.updateAmount', ctrl.getItems);
  };
  ctrl.getItems = function () {
    $http.get('cart/getPriceAmountNextDiscountItems').then(response => {
      ctrl.items = response.data;
    });
  };
}
PriceAmountCartCtrl.$inject = ["$http", "$q"];
export default PriceAmountCartCtrl;